import { render, staticRenderFns } from "./wawaGameListModal.vue?vue&type=template&id=5a6aa733&scoped=true"
import script from "./wawaGameListModal.vue?vue&type=script&lang=js"
export * from "./wawaGameListModal.vue?vue&type=script&lang=js"
import style0 from "./wawaGameListModal.vue?vue&type=style&index=0&id=5a6aa733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6aa733",
  null
  
)

export default component.exports